/* LUCIR EL 3D v3 (Samuel): sobres con visor = pack 3D CSS girando, SIN chip, TODOS PAREJOS.
   Pipeline unico por tarjeta: fuente (knockout pack-pN o foto) -> canvas: quitar blanco por
   flood-fill + RECORTE al bounding box del alpha -> dataURL. El recorte parejo es lo que
   iguala los tamanos (los margenes de cada foto eran distintos). */
(function(){
  var PACK_HANDLES=["2025-nba-select-panini", "booster-bundle-destined-rivals", "booster-bundle-phantasmal-flames", "booster-bundle-mega-evolution-chaos-rising", "eevee-evolutions-premium-collection", "elite-trainer-box-chaos-rising", "ogerpon-ex-premium-collection", "pokemon-elite-trainer-box-black-bolt-1pack", "pokemon-elite-trainer-box-prismatic-evolutions", "baseball-2025-topps-heritage-1-pack", "basketball-2023-24-donruss-fat-1", "basketball-2023-24-topps-chrome-1-pack", "basketball-2024-25-topps-finest-hobby-1-pack", "disney-lorcana-shimmering-skies", "dbs-card-game-new-series-set-01-dbs-b28", "hockey-upper-deck-2020-21-extended-series-1-pack", "mega-evolution-chaos-rising-1-pack", "one-piece-legacy-of-the-master-op-12", "pokemon-ascended-heroes-1-pack", "pokemon-black-bolt-1pck", "pokemon-destined-rivals-1-pack", "pokemon-paldea-evolved-1-pack", "pokemon-phantasmal-flames", "pokemon-shrouded-fable-1-pack", "pokemon-stellar-crown-1-pack", "pokemon-surging-sparks-1-pack", "pokemon-journey-together-1-pack", "pokemon-temporal-forces-1-pack", "pokemon-twilight-masquerade-1-pack", "soccer-2023-24-topps-uefa-womens-hobby-1-pack", "soccer-la-liga-hobby-1-pack", "soccer-premier-league-epl-hobby-1-pack", "soccer-serie-a-hobby-1-pack", "topps-chrome-uefa-club-competitions-2024-25", "topps-holiday-mega-box-basketball-1-pack", "yu-gi-oh-retro-pack-2024"];
  function pick(h,src){
    var i=PACK_HANDLES.indexOf(h);
    return (i>-1 && (window.FANS_PACK_IMGS||[])[i]) || src;
  }
  function process(src,cb){
    var im=new Image(); im.crossOrigin='anonymous';
    im.onload=function(){
      try{
        var c=document.createElement('canvas'); c.width=im.naturalWidth; c.height=im.naturalHeight;
        var x=c.getContext('2d'); x.drawImage(im,0,0);
        var d=x.getImageData(0,0,c.width,c.height), p=d.data, W=c.width, H=c.height;
        var q=[], seen=new Uint8Array(W*H);
        function push(i,j){ if(i<0||j<0||i>=W||j>=H) return; var k=j*W+i; if(seen[k]) return;
          var o=k*4; if(p[o+3]<40 || (p[o]>238&&p[o+1]>238&&p[o+2]>238)){ seen[k]=1; q.push(k); } }
        for(var i=0;i<W;i++){ push(i,0); push(i,H-1); }
        for(var j=0;j<H;j++){ push(0,j); push(W-1,j); }
        while(q.length){ var k=q.pop(); var i2=k%W, j2=(k-i2)/W; p[k*4+3]=0;
          push(i2+1,j2); push(i2-1,j2); push(i2,j2+1); push(i2,j2-1); }
        x.putImageData(d,0,0);
        /* bounding box del contenido: el recorte parejo */
        var x0=W,x1=0,y0=H,y1=0;
        for(var jj=0;jj<H;jj++) for(var ii=0;ii<W;ii++){ if(p[(jj*W+ii)*4+3]>40){ if(ii<x0)x0=ii; if(ii>x1)x1=ii; if(jj<y0)y0=jj; if(jj>y1)y1=jj; } }
        if(x1<=x0||y1<=y0){ cb(src); return; }
        var c2=document.createElement('canvas'); c2.width=x1-x0+1; c2.height=y1-y0+1;
        c2.getContext('2d').drawImage(c,x0,y0,c2.width,c2.height,0,0,c2.width,c2.height);
        cb(c2.toDataURL('image/png'));
      }catch(e){ cb(src); }
    };
    im.onerror=function(){ cb(src); };
    im.src=src;
  }
  function mount(wrap,front){
    var slot=document.createElement('div');
    slot.className='p3dc'; slot.setAttribute('data-pouch3d','');
    slot.setAttribute('data-front',front);
    slot.setAttribute('data-back',window.FANS_FOIL||front);
    wrap.classList.add('haspouch');
    wrap.appendChild(slot);
    if(window.FansMountPouch) window.FansMountPouch(slot);
  }
  function enhance(){
    var M=window.FANS_VIEWERS_MAP||{}; if(!Object.keys(M).length) return;
    document.querySelectorAll('a.fcard, a.pcard').forEach(function(a){
      if(a._p3d) return;
      var m=(a.getAttribute('href')||'').match(/\/products\/([^/?#]+)/); if(!m) return;
      var h=decodeURIComponent(m[1]); var v=M[h];
      if(!v || v.indexOf('viewer-box-')===0) return;
      var wrap=a.querySelector('.fcard-img, .pcard-img'); if(!wrap) return;
      var img=wrap.querySelector('img'); if(!img) return;
      var src=img.currentSrc||img.src; if(!src) return;
      a._p3d=1;
      process(pick(h,src),function(u){ mount(wrap,u); });
    });
  }
  if(document.readyState!=='loading') enhance();
  else document.addEventListener('DOMContentLoaded',enhance);
  var n=0,t=setInterval(function(){ enhance(); if(++n>=12) clearInterval(t); },800);
})();
